import {Component, ElementRef, OnInit} from '@angular/core';
import {CategoryModel} from '../models/category.model';
import {ProductModel} from '../models/product.model';
import {ProductCategoryService} from '../services/product-category.service';

@Component({
  selector: 'app-product-category',
  template: `
  <div class="container">
    <div class="span12">
	<div [innerHTML]="this.srText" aria-live="assertive" aria-atomic="true" class="liveregion sr-only">
	</div>
      <app-header [productLine]="this.lineTitle"></app-header>
      <app-category-selector [model]="this.categories" (categorySelected)="categorySelected($event)"></app-category-selector>
      <app-product-slider [model]="this.products" [productLine]="this.lineTitle" [categories]="this.categories" (productSelected)="productSelected($event)"></app-product-slider>
    </div>
    </div>`,
  styles: [
    `
      @media (min-width: 768px){
        .container{
          max-width:100% !important;
        }
      }

      @media (min-width: 992px){
        .container{
          max-width:100% !important;
        }
      }
    `
  ]
})

export class ProductCatContainerComponent implements  OnInit {
  categories: CategoryModel[] = [];
  lineTitle: string;
  products: ProductModel[] = [];
  srText: String = "The product selection has been updated";
  constructor(private service: ProductCategoryService, private hostElement: ElementRef) {}

  async ngOnInit() {
    const prodLineAtt = this.hostElement.nativeElement.getAttributeNode('product-line');
    const prodLineId: string = prodLineAtt && prodLineAtt.value ? prodLineAtt.value : 'Residential & Light Commercial';

    this.categories = await this.getCategories(prodLineId);

    if (this.categories.length) {

        this.categories[0].selected = true;
        this.products = await this.getproductsForCategory(this.categories[0].id, prodLineId);
    }

    this.lineTitle = prodLineId;
  }

  async categorySelected(catId: string) {

    // mark category as selected and load products
    for (const cat of this.categories) {
      cat.selected = cat.id === catId;
    }
    this.products = await this.getproductsForCategory(catId, this.lineTitle);
  }

  productSelected(prodId: string) {
    window.location.href = `/product-detail/${prodId}`;
  }

  async getCategories(prodLineId: any): Promise<CategoryModel[]> {
    let result: CategoryModel[] = [];
    await this.service.getCategories(prodLineId)
    .then(
      res => {
      if (res) {
        let categoryArray: string[];
        categoryArray = res as string[];
        result =  categoryArray ? categoryArray.map(item => new CategoryModel(item)) : [];
        // result =  res['getProductCategoriesByLineIdResult'] ? res['getProductCategoriesByLineIdResult'].map(item => new CategoryModel(item)) : [];
        return result;
      }
    }

  ).catch(err => console.log(err));
    return result;
  }

  async getproductsForCategory(catId?: string, lineName?: string): Promise<ProductModel[]> {
    let result: ProductModel[] = [];
	this.srText = `The product category selection has been updated to ${catId}`;
    const category: string = catId != null ? catId : this.categories[0].id;
    await this.service.getProducts(category, lineName)
    .then(
      res => {
      if (res) {
        let productArray: any[];
        productArray = res as any[];
        result =  productArray ? productArray.map(item => new ProductModel(item)) : [];
        // result = res['getProductsByCategoryIdResult'] ? res['getProductsByCategoryIdResult'].map(item => new ProductModel(item)) : [];
        return result;
      }
    }
  ).catch(err => console.log(err));
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/app/product-category/containers/product-cat.container.component.ts